module.exports = __webpack_public_path__ + "static/media/storage.34a59b79.svg";